module.exports = __webpack_public_path__ + "static/img/mpdpBottom4.b9bde0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpdpBottom4.png
// module id = ZPyl
// module chunks = 2